module.exports = __webpack_public_path__ + "img/BOWTIE 2 LIME.6acef48.svg";